import { Link } from 'react-router-dom';
import { FACEBOOK, INSTAGRAM } from '../../assets/icons';
import  NAV_LOGO  from '../../assets/logos/World_O_Tutor.webp';
// import { useAppSelector } from '../../hooks';

export default function Footer() {
  // const { userData } = useAppSelector(state => state.userSlice);
  return (
    <>
      <div className="flex lg:flex-row flex-col bg-neutralBlack container mx-auto md:py-10 pt-10 ">
        <div className="lg:flex-1 lg:basis-1/3 w-full">
          <div className="mb-5">
            <img src={NAV_LOGO} alt="world o tutor logo" className='max-w-48' />
          </div>
<div>
            <p className="text-sm font-normal text-white lg:w-4/5 w-full leading-loose mb-4">
              India's largest online platform where thousands of students and teachers across the globe participate in
              an effective educational exchange.
            </p>
            <div className="text-sm font-normal text-white lg:w-4/5 w-full leading-loose">
              <p className="font-semibold mb-2">Our Offices:</p>
              <p className="mb-3">
                <strong>Ludhiana:</strong><br />
                Sco 76, Omaxe residency, Near white bubble, 1st floor<br />
                Pakhowal Road<br />
                LUDHIANA, PUNJAB 142022<br />
                India
              </p>
              <p>
                <strong>Mohali:</strong><br />
                B-415 Bestech Business Tower<br />
                Mohali, Punjab
              </p>
            </div>
          </div>
        </div>
        <div className="lg:flex lg:flex-1 lg:basis-3/4 grid grid-cols-2 grid-rows-2 lg:mt-0 mt-5 justify-between">
          <div className="flex flex-col gap-y-4">
            <span className="text-2xl font-medium text-white">For student</span>
            <Link to={"/find-tutor"}>
              <span className="text-sm font-normal text-white">Find a tutor</span>
            </Link>
            <Link to={"/explore"}>
              <span className="text-sm font-normal text-white">Explore</span>
            </Link>
            {/* {!userData &&
              // <Link to={"/login"}>
              //   <span className="text-sm font-normal text-white">Login as student</span>
              // </Link>
            } */}
          </div>
          <div className="flex flex-col gap-y-4">
            <span className="text-2xl font-medium text-white">For tutors</span>
            <Link to={process.env.REACT_APP_TUTOR_DOMAIN!}>
              <span className="text-sm font-normal text-white">Join as tutor</span>
            </Link>
            <Link to={`${process.env.REACT_APP_TUTOR_DOMAIN!}/login`}>
              <span className="text-sm font-normal text-white">Login as tutor</span>
            </Link>
          </div>
          <div className="flex flex-col gap-y-4 lg:mt-0 mt-3">
            <span className="text-2xl font-medium text-white">Resources</span>
            <Link to={"/legal/student-parent-policy"}>
              <span className="text-sm font-normal text-white">Student & Parent Policy</span>
            </Link>
            <Link to={"/legal/teacher-policy"}>
              <span className="text-sm font-normal text-white">Teacher Policy</span>
            </Link>
            <Link to={"/#faqs"}>
              <span className="text-sm font-normal text-white">FAQs</span>
            </Link>
            <Link to={"/stay-safe"}>
              <span className="text-sm font-normal text-white">Stay Safe</span>
            </Link>
            <Link to={"/share-story"}>
              <span className="text-sm font-normal text-white">Share a story</span>
            </Link>
            {/* <Link to={"/refer"}>
              <span className="text-sm font-normal text-white">Refer Us</span>
            </Link>*/
            <Link to={"/raise-ticket"}>
              <span className="text-sm font-normal text-white">Raise A Ticket</span>
            </Link> }
            <Link to={"/legal/terms-conditions"}>
              <span className="text-sm font-normal text-white">Terms And Conditions</span>
            </Link>

          </div>
          <div className="flex flex-col gap-y-4 lg:items-center items-start lg:mt-0 mt-3">
            <span className="text-xl font-medium text-white">Follow Us</span>
            <div className="flex gap-5">
              <img src={FACEBOOK} alt="Facebook logo" />
              <img src={INSTAGRAM} alt="Instagram logo" />
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto bg-neutralBlack py-5">
        <footer className="border-t-2 border-white py-4">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="text-center lg:text-start  w-min">
              <p className="text-white font-normal whitespace-nowrap">
                &copy; <strong>2025 All rights reserved</strong>
              </p>
            </div>
            <div className="flex-1  md:flex grid grid-cols-2 grid-rows-2 text-center lg:pt-0 pt-2 lg:w-4/5 w-full md:justify-end justify-center">
              <Link to="/#testimonials" className="py-2 px-4 text-white text-sm hover:underline">
                Testimonials
              </Link>
              <Link to="/legal/terms-conditions" className="py-2 px-4 text-white text-sm hover:underline">
                Terms of Service
              </Link>
              <Link to="/legal/privacy-policy" className="py-2 px-4 text-white text-sm hover:underline">
                Privacy Policy
              </Link>
              <Link to="/refund-policy" className="py-2 px-4 text-white text-sm hover:underline">
                Refund Policy
              </Link>
            </div>
            {/* <div className="w-min text-center lg:text-end">
              <a
                href="https://www.flexxited.com"
                target="_blank"
                rel="noreferrer"
                className="py-2 px-4 text-white text-sm font-normal inline-block hover:underline whitespace-nowrap"
              >
                Designed & developed by flexxited
              </a>
            </div> */}
          </div>
        </footer>
      </div>
    </>
  );
}
